import controller from './controller';
import template from './template.html';

const controllerAs = 'marketplaceRegisterCtrl';
const bindings = {};

export { template, controller, controllerAs, bindings };



// WEBPACK FOOTER //
// ./src/app/modals/marketplaceRegister/index.js